"use strict";
var BindingScope;
(function (BindingScope) {
    BindingScope[BindingScope["Transient"] = 0] = "Transient";
    BindingScope[BindingScope["Singleton"] = 1] = "Singleton";
})(BindingScope || (BindingScope = {}));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BindingScope;



//////////////////
// WEBPACK FOOTER
// ./~/inversify/lib/bindings/binding_scope.js
// module id = 9
// module chunks = 0